import type { NodeProps } from '@xyflow/react';
import type { CanvasNodeData } from '@/hooks/useProcessCanvas';
import { BaseNode } from './BaseNode';

export function StepNode({ id, data }: NodeProps) {
  const d = data as unknown as CanvasNodeData;
  const stepBadge =
    d.stepNumber != null ? (
      <span
        className="inline-flex items-center rounded-[5px] px-1.5 py-[2px] text-[9.5px] font-medium tracking-[0.04em]"
        style={{
          background: 'hsl(var(--type-step) / 0.10)',
          color: 'hsl(var(--type-step))',
          lineHeight: 1,
        }}
      >
        Step {String(d.stepNumber).padStart(2, '0')}
      </span>
    ) : undefined;

  return (
    <BaseNode
      nodeId={id}
      label={d.label}
      description={d.description}
      sourceType={d.sourceType}
      canvasNodeType="step"
      edgeCount={d.edgeCount}
      staged={d.staged}
      contextCount={d.additionalContext?.length ?? 0}
      badge={stepBadge}
    />
  );
}
